/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FindLeadQueryResponse
 */
export interface FindLeadQueryResponse {
    /**
     * Lead id
     * @type {string}
     * @memberof FindLeadQueryResponse
     */
    id: string;
    /**
     * Token
     * @type {string}
     * @memberof FindLeadQueryResponse
     */
    token: string;
}

/**
 * Check if a given object implements the FindLeadQueryResponse interface.
 */
export function instanceOfFindLeadQueryResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "token" in value;

    return isInstance;
}

export function FindLeadQueryResponseFromJSON(json: any): FindLeadQueryResponse {
    return FindLeadQueryResponseFromJSONTyped(json, false);
}

export function FindLeadQueryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindLeadQueryResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'token': json['token'],
    };
}

export function FindLeadQueryResponseToJSON(value?: FindLeadQueryResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'token': value.token,
    };
}

